import { api, unwrap } from "./httpClient";
import type {
  Payment,
  CreatePaymentPayload,
  ConfirmPaymentPayload,
  CryptoWalletSettings,
} from "../types/api";

export const listPayments = () =>
  unwrap<Payment[]>(api({ method: "GET", url: "/payments" }));

export const getPaymentById = (paymentId: number) =>
  unwrap<Payment>(api({ method: "GET", url: `/payments/${paymentId}` }));

export const createPayment = (payload: CreatePaymentPayload) =>
  unwrap<Payment>(api({ method: "POST", url: "/payments", data: payload }));

export const confirmPayment = (paymentId: number, payload: ConfirmPaymentPayload) =>
  unwrap<Payment>(
    api({ method: "POST", url: `/payments/${paymentId}/confirm`, data: payload })
  );

export const cancelPayment = (paymentId: number) =>
  unwrap<Payment>(
    api({ method: "POST", url: `/payments/${paymentId}/cancel` })
  );

export const getCryptoWallets = () =>
  unwrap<CryptoWalletSettings>(api({ method: "GET", url: "/payments/crypto-wallets" }));

